import React, { useState, useContext } from 'react';
import axios from '../../../../axios/index';

// context
import { UserContext } from './../../../Context/UserContextProvider';


import Modal from 'react-bootstrap/Modal';
import ReminderPortalDatePicker from './ReminderPortalDatePicker';
import ReminderTimePicker from './ReminderTimePicker';

// styles
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css"
import styles from "./ReminderPortal.module.css"
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"

const ReminderModal = (props) => {
    const { userToken } = useContext(UserContext);
    const [error, setError] = useState(false)
    const [btnLoader, setBtnLoader] = useState(false)

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            تنظیم یادآور
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body dir='rtl'>
                    <div className='w-100 d-flex flex-column align-items-center justify-content-center py-2 flex-wrap'>
                        <div className={`w-100 d-flex align-items-center justify-content-center my-4 ${styles.text_bold}`}>
                            روز و ساعت یادآور را انتخاب کنید
                        </div>

                        <div className={`w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap pt-0 px-3 mb-4`}>
                            <div className={`d-flex align-items-start justify-content-center flex-column my-3 ${styles.input_container1}`}>
                                <div className={`mb-3 ${styles.input_top_title}`}>
                                    عنوان یادآور
                                </div>
                                <input
                                    className={styles.input}
                                    type="text"
                                    name="title"
                                    value={props.addedReminderData.title}
                                    onChange={changeHandler}
                                />
                            </div>
                            <ReminderPortalDatePicker data={props.addedReminderData.dateValue} setData={props.setAddedReminderData} />
                        </div>

                        <div className='w-100 d-flex align-items-center justify-content-between pt-0 px-3 mb-5 mx-2'>
                            <ReminderTimePicker data={props.addedReminderData.hourValue} setData={props.setAddedReminderData} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 flex-column d-flex justify-content-center align-items-center mb-3'>
                        {btnLoader ? (
                            <div className={Dstyles.btn_loader_container}>
                                <div className={Dstyles.btn_spinner}></div>
                            </div>
                        ) : (
                            <div div className={`d-flex align-items-center justify-content-center me-3 ${ModalStyles.filled_btn}`} onClick={clickHandler}>
                                ذخیره
                            </div>
                        )}
                        {error
                            &&
                            <span className='text-danger mt-4'>لطفا تمام فیلد هارا پر کنید!</span>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );

    function changeHandler(event) {
        props.setAddedReminderData((prev) => {
            return { ...prev, [event.target.name]: event.target.value };
        });
    };

    async function clickHandler() {
        if (props.addedReminderData.dateValue === "" | props.addedReminderData.hourValue === "" | props.addedReminderData.title === "") {
            setError(true)
        } else {
            setBtnLoader(true)
            const RminderTitle = props.addedReminderData.title
            const RminderReminderDate = `${props.addedReminderData.dateValue.year}/${props.addedReminderData.dateValue.month.number}/${props.addedReminderData.dateValue.day}`
            const RminderReminderTime = `${props.addedReminderData.hourValue.hour}:${props.addedReminderData.hourValue.minute}`

            var data = new FormData();
            data.append('ObjectId', props.id);
            data.append('ReminderFor', 2);
            data.append('Title', RminderTitle);
            data.append('ReminderDate', RminderReminderDate);
            data.append('ReminderTime', RminderReminderTime);

            const apiData = await axios.post(
                "Reminder",
                data,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            window.location.reload(false)
            props.onHide()
        }
    };
};

export default ReminderModal;